// extracted by mini-css-extract-plugin
export var __icon = "header-module--__icon--dfbed";
export var button = "header-module--button--82f33";
export var globalMenu = "header-module--global-menu--59147";
export var globalMenu__list = "header-module--global-menu__list--87927";
export var header = "header-module--header--51a07";
export var headerMenu = "header-module--header-menu--3e5c4";
export var headerMenu__button = "header-module--header-menu__button--88972";
export var headerSearch = "header-module--header-search--cd341";
export var headerSearch__button = "header-module--header-search__button--1c81e";
export var headerSearch__input = "header-module--header-search__input--5d2ad";
export var header__logo = "header-module--header__logo--97f74";
export var infoMenu = "header-module--info-menu--6325a";
export var infoMenu__list = "header-module--info-menu__list--c5b73";
export var isNavOpen = "header-module--is-nav-open--2f6eb";
export var isScrolled = "header-module--is-scrolled--c704e";
export var isTransparent = "header-module--is-transparent--9e32b";
export var listLower = "header-module--list-lower--b809d";
export var open = "header-module--open--0fe80";
export var switchLowerList = "header-module--switch-lower-list--44f6c";